import AlertCircleIcon from '@/icons/AlertCircleIcon.svg?react';
import CheckCircleIcon from '@/icons/CheckCircleIcon.svg?react';
import IncompleteCircleIcon from '@/icons/IncompleteCircleIcon.svg?react';
import ProgressStarIcon from '@/icons/ProgressStarIcon.svg?react';
import { isRunIncomplete } from '@/utils/get-run-incomplete-status';

import { RunSchema } from '../types/schema';

export function RunStatusIcon(props: { run: RunSchema }) {
  if (props.run.status === 'success') {
    return (
      <div
        data-testid="run-status-icon-success"
        className="flex h-6 w-6 items-center justify-center rounded-full bg-success-primary text-status-green"
      >
        <CheckCircleIcon className="h-5 w-5" />
      </div>
    );
  }

  if (props.run.status === 'pending') {
    // todo: send the incomplete state from backend
    if (isRunIncomplete(props.run)) {
      return (
        <div
          data-testid="run-status-icon-pending"
          className="flex h-6 w-6 items-center justify-center rounded-full bg-warning-primary text-status-orange"
        >
          <IncompleteCircleIcon className="h-5 w-5" />
        </div>
      );
    }

    return (
      <div
        data-testid="run-status-icon-pending"
        className="flex h-6 w-6 animate-spin items-center justify-center rounded-full bg-brand-tertiary text-brand-primary"
      >
        <ProgressStarIcon className="h-5 w-5" />
      </div>
    );
  }
  if (props.run.status === 'interrupted') {
    return (
      <div
        data-testid="run-status-icon-interrupted"
        className="flex h-6 w-6 items-center justify-center rounded-full bg-purple text-purple"
      >
        <AlertCircleIcon className="h-5 w-5" />
      </div>
    );
  }
  return (
    <div
      data-testid="run-status-icon-error"
      className="flex h-6 w-6 items-center justify-center rounded-full bg-error-primary text-status-red"
    >
      <AlertCircleIcon className="h-5 w-5" />
    </div>
  );
}
